export const repairStatusConfig: Record<string, { color: string; bgColor: string }> = {
  Open: { color: 'text-warning', bgColor: 'bg-warning/15' },
  Acknowledged: { color: 'text-info', bgColor: 'bg-info/15' },
  InProgress: { color: 'text-primary', bgColor: 'bg-primary/15' },
  WaitingParts: { color: 'text-warning', bgColor: 'bg-warning/15' },
  Completed: { color: 'text-success', bgColor: 'bg-success/15' },
  Closed: { color: 'text-muted-foreground', bgColor: 'bg-muted/15' },
}

export const priorityConfig: Record<string, { color: string; bgColor: string }> = {
  Low: { color: 'text-muted-foreground', bgColor: 'bg-muted/15' },
  Medium: { color: 'text-info', bgColor: 'bg-info/15' },
  High: { color: 'text-warning', bgColor: 'bg-warning/15' },
  Critical: { color: 'text-destructive', bgColor: 'bg-destructive/15' },
}
